import { fetchUserPermissions } from '@/api/business/user'
import { useQuery } from '@tanstack/react-query'

export const UserPermissionsKey = {
    all: ['userpermissions'] as const,
    lists: () => [...UserPermissionsKey.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...UserPermissionsKey.lists(), page, perPage, filters] as const,
    details: () => [...UserPermissionsKey.all, 'detail'] as const,
    detail: (params: number) => [...UserPermissionsKey.details(), params] as const,
}

export const useUserPermissionsQuery = (SK_USUARIO: number, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus,
        queryFn:  () => fetchUserPermissions(SK_USUARIO),
        queryKey: UserPermissionsKey.detail(SK_USUARIO),
    })
}
